import type {Component, ComponentEvents} from "./Component.js";

/** Attaches a component tree to an existing DOM element. */
export const mount = (rootElement: HTMLElement, component: Component<ComponentEvents>): void => {
    rootElement.classList.add("juis");
    rootElement.appendChild(component.node.element);
};

export {DomNode} from "./DomNode.js";
export {Property} from "./Property.js";
export {
    Component,
    createTextComponent,
    type ComponentEvents,
    type ComponentOptions,
    type NavigationRequest
} from "./Component.js";
export {Container} from "./Container.js";
export * from "./tags.js";
export * from "./domEvents.js";
